import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader-standalone',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader-standalone.component.html',
  styleUrl: './loader-standalone.component.scss',
})
export class LoaderStandaloneComponent {
  @Input() size: string = '';
}
